import React from 'react'

function About() {
    return (
        <>
         <section className="about">

            <div class="container mt-5 mb-5">
                <div class="a_plan_for position-relative">
                    <img src="/assets/img/a_plan_bg.webp" alt="a_plan" class="a_plan_bg"/>
                        <div class="row position-relative">
                            <div class="col-md-5 ms-auto">
                                <h2 class="hadding mb-4    ">A Plan for Every Unique Journey</h2>
                                <h3 class="  mb-4    ">Starting from just ₹9,990!</h3>
                                <p class=" mb-md-4 mb-3 ">One Goal: Better Health. Three Ways to Get There. <br/>
                                    We have a plan tailored for YOU</p>
                                <a href="#" class="btn">See all Programs</a>
                            </div>


                        </div>
                </div>
            </div>
            </section>

        </>
    )
}

export default About